import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'
import { DROP_JOINED_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { generateMaxDaresText } from 'root/src/client/logic/project/thunks/createProjectDrop'
import toast from 'react-hot-toast'
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants'

export default (id, status, dropEvent) => async (dispatch, getState) => {
	const state = getState()

	if (status) {
		dispatch(displayModal(DROP_JOINED_MODAL_MODULE_ID))
	}

	const { error } = await invokeApiRequest(
		dropEndpointIds.SET_EMAIL_SUBSCRIPTION_DROP,
		{ id, status, dropEvent },
		state,
	)

	if (error) {
		toast.error('Your connected accounts do not meet the requirements for this drop')
		const { assigneesNotSatisfying } = error.props
		const [{ followerCount, averageCcv, maxDares, platform }] = assigneesNotSatisfying
		// why do we throw max dares text here?
		throw { error: generateMaxDaresText(followerCount, averageCcv, maxDares, platform) }
	}
}
